import { put } from 'redux-saga/effects';
import { batchActions } from 'redux-batched-actions';
import { setTravellers } from './travellers/actions';
import { createInitialOrderTravellers } from '../lib/createInitialOrderTravellers';
export function* createInitialOrderStateSagas({ payload }) {
    const actions = [
        setTravellers(createInitialOrderTravellers(payload.travellers))
    ];
    yield put(batchActions(actions));
}
